if (!customElements.get('size-chart-units')) {
  customElements.define(
    'size-chart-units',
    class SizeChartUnits extends HTMLElement {
      static FRACTIONS = { '⅛': 0.125, '¼': 0.25, '⅜': 0.375, '½': 0.5, '⅝': 0.625, '¾': 0.75, '⅞': 0.875 };

      constructor() {
        super();
        this.sourceUnit = this.dataset.unit;
        this.addEventListener('click', this.onClick.bind(this));
      }

      onClick(event) {
        const button = event.target.closest('button[data-unit]');
        if (!button) return;
        this.setUnit(button.dataset.unit);
      }

      setUnit(unit) {
        this.querySelectorAll('button[data-unit]').forEach((button) => {
          button.setAttribute('aria-pressed', String(button.dataset.unit === unit));
        });

        const dialog = this.closest('[role="dialog"]');
        if (!dialog) return;

        let factor = null;
        if (unit !== this.sourceUnit) factor = unit === 'cm' ? 2.54 : 1 / 2.54;

        dialog.querySelectorAll('[data-size-chart-value]').forEach((cell) => {
          if (cell.dataset.source === undefined) cell.dataset.source = cell.textContent.trim();
          cell.textContent = factor ? this.convert(cell.dataset.source, factor) : cell.dataset.source;
        });
      }

      // Converts every number in a cell, including "26 1/2" and "26½" style fractions.
      convert(text, factor) {
        return text.replace(
          /(\d+(?:\.\d+)?)(?:\s*([⅛¼⅜½⅝¾⅞])|\s+(\d+)\/(\d+))?/g,
          (match, whole, glyph, numerator, denominator) => {
            let value = parseFloat(whole);
            if (glyph) value += SizeChartUnits.FRACTIONS[glyph];
            if (numerator && denominator) value += Number(numerator) / Number(denominator);
            return String(Math.round(value * factor * 10) / 10);
          }
        );
      }
    }
  );
}
